
import { Component, Vue, Prop } from 'vue-property-decorator'

import Booking from '@/models/booking'

@Component
export default class DisalableBookingElementMixin extends Vue {
  @Prop() booking!: Booking

  private DISABLED_STATUSES = ['expired', 'cancelled']

  get isDisabled() {
    return this.booking && this.DISABLED_STATUSES.includes(this.booking.status)
  }
}
